export const validateEmail = (email: string) => {
  // eslint-disable-next-line no-useless-escape
  const isEmailFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  return isEmailFormat;
};
